import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { get_tdk } from "api/server/tdk";
import { Context, Util, Hooks, Platform } from "@xt/xtbase";
import { useRouter } from "next/router";
const {getOrigin} = Util;
import Banner from "@/components/Pages/affiliate/banner";
import Content from "@/components/Pages/affiliate/content"

const {XtContext} = Context;
const {useTranslation} = Hooks;
export default function PageIndex(props) {
  const [appState] = React.useContext(XtContext);
  const {lang} = appState;
  const router = useRouter();
  const t = useTranslation();

  const handleBack = () => {
    router.back();
  };

  const mainEntityMap = {
    'en': `[{
      "@type": "Question",
      "name": "What is the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>We are looking for partners who agree with XT values and XT mission, and are willing to promote XT, so we launched the XT affiliate program. In this program, you can create a unique referral link, anyone who clicks on the link and completes the registration will be automatically classified as your referee. You can adjust the ratio and earn commission whenever your referees complete any trade across XT spot, margin, and futures trading. </p>"
      }
    }, {
      "@type": "Question",
      "name": "Who can join the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. YouTube video bloggers, cryptocurrency community leaders, media authors and other content creators who are willing to promote XT.</li><li>2. Cryptocurrency-related market websites, encryption tool websites, crypto industry media websites and other cryptocurrency websites.</li><li>3. Promotion agency, institution or organization, etc.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "How to earn commission through the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>After successfully becoming an XT affiliate, you can use your referral link to invite friends to trade on XT, and get a commission return of up to 55% of the invitee's transaction fees. You can also create special referral links with different fee discounts to increase invitation efficiency.</p>"
      }
    }, {
      "@type": "Question",
      "name": "How long can I enjoy affiliate commissions if I join the program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>As long as you meet the corresponding program requirements, you can get a lifetime commission provided by the referee. There is no upper limit and time limit for lifetime commission. The more users you invite, the more trading they make, and the higher the commission you get.</p>"
      }
    }, {
      "@type": "Question",
      "name": "How can I get higher level commissions in XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>We will evaluate each month based on the trading volume brought by our affiliate. If the affiliate can reach the threshold of the minimum trading volume of the specified level, they will get the commission ratio of that level.</p>"}
    }]`,
    'id': `[{
    "@type": "Question",
    "name": "什么是XT合伙人计划？",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "<p>我们在寻找认同XT价值观和XT使命，并愿意推广XT的合伙人，因此我们推出了XT合伙人计划，在该计划的后台中，您可以创建独一无二的推荐链接，任何人点击链接并完成注册，即可自动划归为您的被推荐人。无论是XT现货还是合约您都可以调整比例，从被邀请人完成的所有交易中获得佣金。</p>"
    }
  }, {
    "@type": "Question",
    "name": "谁可以加入XT合伙人计划？",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": " <ul><li>1. 愿意推广XT的YouTube视频博主、数字货币社区领袖、媒体作者以及其他内容创作者。</li><li>2. 加密货币相关行情网站、加密工具网站、行业媒体网站等加密货币网站。</li><li>3. 推广代理、机构或组织等</li></ul> "
    }
  }, {
    "@type": "Question",
    "name": "如何通过XT合伙人计划赚取佣金奖励？",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "<p>成功成为XT合伙人后，您可以使用自己的推荐链接邀请好友在XT进行交易，获得被邀请人交易费用最高55%的佣金返还。您还可以创建具有不同费用折扣的特殊推荐链接，以提高邀请效率。</p>"
    }
  }, {
    "@type": "Question",
    "name": "如果我加入该计划，我可以享受多久的会员佣金？",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "<p>只要达到对应的门槛要求，你可以获得受邀人提供的终身返佣。终身返佣——没有上限和时间限制。邀请的用户越多交易得越多，获得的返佣越高。</p>"
    }
  }, {
    "@type": "Question",
    "name": "我在XT如何获得更高等级返佣？",
    "acceptedAnswer": {
      "@type": "Answer",
      "text":"<p>我们每月会根据合伙人所带来的交易量进行评估，如果能够到达指定等级最低交易量的门槛，那么将会获得该等级的返佣比例。</p>"}
    }]`,
    'vi': `[{
      "@type": "Question",
      "name": "Chương trình Đối tác XT là gì",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Chúng tôi đang tìm kiếm các đối tác chia sẻ các giá trị và sứ mệnh của XT, đồng thời sẵn sàng quảng bá XT, vì vậy chúng tôi đã khởi chạy Chương trình Đối tác XT, nơi bạn có thể tạo một liên kết giới thiệu duy nhất trong nền tảng và bất kỳ ai nhấp vào liên kết và hoàn tất đăng ký sẽ tự động được phân loại là người được giới thiệu của bạn. Cho dù đó là XT Spot hay Futures, bạn có thể điều chỉnh tỷ lệ và nhận hoa hồng cho tất cả các giao dịch do người được mời hoàn thành.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Ai có thể tham gia Chương trình Đối tác XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. Các blogger video YouTube, lãnh đạo cộng đồng tiền kỹ thuật số, người viết phương tiện truyền thông và những người sáng tạo nội dung khác, những người sẵn sàng quảng bá XT.</li><li>2. Trang web thị trường tiền điện tử, trang web công cụ mã hóa, trang web truyền thông công nghiệp và các trang web tiền điện tử khác.</li><li>3. Quảng cáo đại lý, cơ quan hoặc tổ chức, v.v.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "Làm cách nào để kiếm phần thưởng hoa hồng thông qua Chương trình liên kết XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Khi bạn đã trở thành Đối tác XT thành công, bạn có thể sử dụng liên kết giới thiệu của mình để giới thiệu bạn bè giao dịch với XT và nhận hoa hồng lên tới 55% phí giao dịch của người được mời. Bạn cũng có thể tạo các liên kết giới thiệu đặc biệt với các mức chiết khấu phí khác nhau để tăng hiệu quả cho lời mời của mình.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Tôi có thể hưởng hoa hồng thành viên trong bao lâu nếu tham gia chương trình?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Bằng cách đáp ứng các yêu cầu về ngưỡng, bạn có thể nhận được chiết khấu trọn đời từ người được mời. Giảm giá trọn đời - không có giới hạn trên hoặc giới hạn thời gian. Bạn mời càng nhiều người dùng giao dịch, bạn càng nhận được nhiều tiền, bạn nhận được khoản chiết khấu càng cao.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Làm thế nào tôi có thể nhận được giới thiệu cấp cao trong XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>Các đối tác được đánh giá hàng tháng dựa trên số tiền giao dịch mà họ mang lại, nếu họ đạt đến ngưỡng giao dịch thấp nhất cho một cấp độ nhất định, họ sẽ nhận được tỷ lệ chiết khấu cho cấp độ đó.</p>"}
    }]`,
    'tr': `[{
      "@type": "Question",
      "name": "XT İş Ortağı Programı nedir?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>XT'nin değerlerini ve misyonunu paylaşan ve XT'yi tanıtmaya istekli ortaklar arıyoruz, bu nedenle platformda benzersiz bir yönlendirme bağlantısı oluşturabileceğiniz ve bağlantıya tıklayan ve kaydı tamamlayan herkesin otomatik olarak hakeminiz olarak sınıflandırılacağı XT Ortak Programını başlattık. İster XT Spot ister Vadeli İşlemler olsun, oranı ayarlayabilir ve davet edilen kişi tarafından tamamlanan tüm işlemlerden komisyon alabilirsiniz.</p>"
      }
    }, {
      "@type": "Question",
      "name": "XT İş Ortağı Programına kimler katılabilir?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. YouTube video blogcuları, dijital para topluluğu liderleri, medya yazarları ve XT'yi tanıtmak isteyen diğer içerik oluşturucular.</li><li>2. Kripto para ile ilgili pazar web siteleri, şifreleme aracı web siteleri, endüstri medya web siteleri ve diğer kripto para web siteleri.</li><li>3. Acenteleri, ajansları veya kuruluşları vb. tanıtmak.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "XT Ortaklık Programı aracılığıyla komisyon ödülleri nasıl kazanılır?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Başarılı bir şekilde XT Ortağı olduktan sonra, arkadaşlarınızı XT ile işlem yapmaya yönlendirmek için yönlendirme bağlantınızı kullanabilir ve davetlinin işlem ücretlerinin %55'ine kadar komisyon alabilirsiniz. Davetlerinizin verimliliğini artırmak için farklı ücret indirimleri içeren özel yönlendirme bağlantıları da oluşturabilirsiniz.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Programa katılırsam üye komisyonlarından ne kadar süreyle yararlanabilirim?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Eşik gereksinimlerini karşılayarak, davet sahibinden ömür boyu indirim alabilirsiniz. Ömür boyu indirim - üst sınır veya zaman sınırı yoktur. Ne kadar çok kullanıcıyı işlem yapmaya davet ederseniz, alacağınız indirim o kadar yüksek olur.</p>"
      }
    }, {
      "@type": "Question",
      "name": "XT'de üst düzey yönlendirmeleri nasıl alabilirim?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>Ortaklar, getirdikleri ticaret miktarlarına göre aylık olarak değerlendirilir, belirli bir seviye için en düşük ticaret eşiğine ulaşırlarsa, o seviye için bir indirim oranı alırlar.</p>"}
    }]`,
    'th': `[{
      "@type": "Question",
      "name": "โปรแกรมพันธมิตร XT คืออะไร?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>เรากําลังมองหาพันธมิตรที่แบ่งปันค่านิยมและภารกิจของ XT และยินดีที่จะโปรโมต XT ดังนั้นเราจึงได้เปิดตัว XT Partner Program ซึ่งคุณสามารถสร้างลิงก์อ้างอิงที่ไม่ซ้ํากันในแพลตฟอร์มและทุกคนที่คลิกลิงก์และลงทะเบียนให้เสร็จสมบูรณ์จะถูกจัดประเภทเป็นผู้ตัดสินของคุณโดยอัตโนมัติ ไม่ว่าจะเป็น XT Spot หรือ Futures คุณสามารถปรับอัตราส่วนและรับค่าคอมมิชชั่นจากการซื้อขายทั้งหมดที่ผู้รับเชิญทําสําเร็จ</p>"
      }
    }, {
      "@type": "Question",
      "name": "ใครสามารถเข้าร่วมโปรแกรมพันธมิตร XT ได้บ้าง",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. บล็อกเกอร์วิดีโอ YouTube ผู้นําชุมชนสกุลเงินดิจิทัลนักเขียนสื่อและผู้สร้างเนื้อหาอื่น ๆ ที่ยินดีโปรโมต XT</li><li>2. เว็บไซต์ตลาดสกุลเงินดิจิทัล เว็บไซต์เครื่องมือเข้ารหัส เว็บไซต์สื่ออุตสาหกรรม และเว็บไซต์สกุลเงินดิจิทัลอื่นๆ</li><li>3. ประชาสัมพันธ์ตัวแทน หน่วยงาน หรือองค์กรต่างๆ เป็นต้น</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "จะได้รับรางวัลคอมมิชชั่นผ่านโปรแกรมพันธมิตร XT ได้อย่างไร?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>เมื่อคุณเป็นพันธมิตร XT สำเร็จแล้ว คุณสามารถใช้ลิงก์อ้างอิงของคุณเพื่อแนะนำเพื่อนให้ซื้อขายกับ XT และรับค่าคอมมิชชั่นสูงถึง 55% ของค่าธรรมเนียมการทำธุรกรรมของผู้ได้รับเชิญ คุณยังสามารถสร้างลิงค์อ้างอิงพิเศษพร้อมส่วนลดค่าธรรมเนียมต่างๆ เพื่อเพิ่มประสิทธิภาพของคำเชิญของคุณ</p>"
      }
    }, {
      "@type": "Question",
      "name": "ฉันสามารถรับค่าคอมมิชชั่นสมาชิกได้นานแค่ไหนหากฉันเข้าร่วมโปรแกรม?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>เมื่อปฏิบัติตามข้อกำหนดเกณฑ์ คุณจะได้รับเงินคืนตลอดชีพจากผู้ได้รับเชิญ เงินคืนตลอดชีพ - ไม่มีขีดจำกัดสูงสุดหรือขีดจำกัดเวลา ยิ่งคุณเชิญผู้ใช้ให้ซื้อขายมากเท่าไหร่ คุณก็ยิ่งได้รับเงินคืนมากเท่านั้น</p>"
      }
    }, {
      "@type": "Question",
      "name": "ฉันจะได้รับการอ้างอิงระดับสูงใน XT ได้อย่างไร",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>พันธมิตรจะได้รับการประเมินรายเดือนเกี่ยวกับจํานวนการซื้อขายที่พวกเขานํามาหากพวกเขาถึงเกณฑ์การซื้อขายต่ําสุดสําหรับระดับที่กําหนดพวกเขาจะได้รับอัตราส่วนเงินคืนสําหรับระดับนั้น</p>"}
    }]`,
    'ru': `[{
      "@type": "Question",
      "name": "Что такое партнерская программа XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Мы ищем партнеров, которые разделяют ценности и миссию XT и готовы продвигать XT, поэтому мы запустили партнерскую программу XT, в рамках которой вы можете создать уникальную реферальную ссылку в платформе, и любой, кто перейдет по ссылке и завершит регистрацию, будет автоматически классифицирован как ваш реферал. Будь то XT Spot или Futures, вы можете регулировать соотношение и получать комиссию со всех сделок, совершенных приглашенным лицом.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Кто может стать участником партнерской программы XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. Видеоблогеры YouTube, лидеры сообщества цифровых валют, авторы СМИ и другие создатели контента, которые готовы продвигать XT.</li><li>2. Сайты криптовалютного рынка, сайты инструментов для шифрования, сайты отраслевых СМИ и другие криптовалютные сайты.</li><li>3. Продвигать агентов, агентства или организации и т.д.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "Как зарабатывать комиссионные вознаграждения через партнерскую программу XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>После того как вы успешно стали партнером XT, вы можете использовать свою реферальную ссылку для привлечения друзей к торговле с XT и получать комиссионные в размере до 55% от комиссионных за транзакцию приглашенного. Вы также можете создавать специальные реферальные ссылки с различными скидками на комиссионные для повышения эффективности ваших приглашений.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Как долго я смогу пользоваться членскими комиссионными, если присоединюсь к программе?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Выполнив пороговые требования, вы можете получить пожизненную скидку от приглашающей стороны. Пожизненный рибейт - нет верхнего предела или ограничения по времени. Чем больше пользователей вы приглашаете к торговле, тем больше вы получаете, тем больше рибейт вы получаете.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Как я могу получить рефералов высокого уровня в XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>Партнеры ежемесячно оцениваются по объему торговли, который они приносят, если они достигают самого низкого порога торговли для данного уровня, они получают коэффициент возврата для этого уровня.</p>"}
    }]`,
    'ja': `[{
      "@type": "Question",
      "name": "XTパートナープログラムとは？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>XTの価値と使命を共有し、XTを推進する意思のあるパートナーを求めています。そこで、XTパートナープログラムを開始しました。プラットフォームで独自の紹介リンクを作成し、リンクをクリックして登録を完了した人は、自動的にあなたの紹介者として分類されます。XTスポットでも先物でも、あなたは比率を調整し、招待者が完了したすべての取引に対して手数料を受け取ることができます。</p>"
      }
    }, {
      "@type": "Question",
      "name": "XTパートナープログラムに参加できるのは誰ですか？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1.YouTubeビデオブロガー、デジタル通貨コミュニティリーダー、メディアライター、その他XTを宣伝してくれるコンテンツクリエイター。</li><li>2.暗号通貨市場ウェブサイト、暗号化ツールウェブサイト、業界メディアウェブサイト、その他の暗号通貨ウェブサイト。</li><li>3.代理店・扱者・組織などの宣伝</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "XTアフィリエイト・プログラムでコミッション報酬を得るには？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>XTパートナーになることに成功したら、紹介リンクを使って友人にXTでの取引を紹介し、招待者の取引手数料の最大55％を手数料として受け取ることができます。また、手数料の割引率が異なる特別な紹介リンクを作成し、招待の効率を高めることもできます。</p>"
      }
    }, {
      "@type": "Question",
      "name": "プログラムに参加すると、どのくらいの期間、メンバーコミッションを享受できますか？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>閾値の条件を満たすことで、招待主から生涯リベートを受け取ることができます。ライフタイムリベート - 上限や時間制限はありません。取引に招待するユーザーが多ければ多いほど、受け取れるリベートも高くなります。</p>"
      }
    }, {
      "@type": "Question",
      "name": "XTで上位の紹介を受けるにはどうしたらよいですか？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>パートナーは、毎月の取引額で評価され、あるレベルの最低取引額に達すると、そのレベルのリベート率を受け取ることができます。</p>"}
    }]`,
    'hi': `[{
      "@type": "Question",
      "name": "What is the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>We are looking for partners who agree with XT values and XT mission, and are willing to promote XT, so we launched the XT affiliate program. In this program, you can create a unique referral link, anyone who clicks on the link and completes the registration will be automatically classified as your referee. You can adjust the ratio and earn commission whenever your referees complete any trade across XT spot, margin, and futures trading. </p>"
      }
    }, {
      "@type": "Question",
      "name": "Who can join the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. YouTube video bloggers, cryptocurrency community leaders, media authors and other content creators who are willing to promote XT.</li><li>2. Cryptocurrency-related market websites, encryption tool websites, crypto industry media websites and other cryptocurrency websites.</li><li>3. Promotion agency, institution or organization, etc.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "How to earn commission through the XT Affiliate Program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>After successfully becoming an XT affiliate, you can use your referral link to invite friends to trade on XT, and get a commission return of up to 55% of the invitee's transaction fees. You can also create special referral links with different fee discounts to increase invitation efficiency.</p>"
      }
    }, {
      "@type": "Question",
      "name": "How long can I enjoy affiliate commissions if I join the program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>As long as you meet the corresponding program requirements, you can get a lifetime commission provided by the referee. There is no upper limit and time limit for lifetime commission. The more users you invite, the more trading they make, and the higher the commission you get.</p>"
      }
    }, {
      "@type": "Question",
      "name": "How can I get higher level commissions in XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>We will evaluate each month based on the trading volume brought by our affiliate. If the affiliate can reach the threshold of the minimum trading volume of the specified level, they will get the commission ratio of that level.</p>"}
    }]`,
    'es': `[{
      "@type": "Question",
      "name": "¿Qué es el Programa XT Partner?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Buscamos socios que compartan los valores y la misión de XT, y que estén dispuestos a promocionar XT, por lo que hemos lanzado el Programa de Socios XT, en el que puede crear un enlace de referencia único en la plataforma y cualquiera que haga clic en el enlace y complete el registro será clasificado automáticamente como su referido. Tanto si se trata de XT Spot como de Futuros, puede ajustar el ratio y recibir una comisión por todas las operaciones completadas por el invitado.</p>"
      }
    }, {
      "@type": "Question",
      "name": "¿Quién puede participar en el Programa de Socios XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. Video bloggers de YouTube, líderes de la comunidad de la moneda digital, escritores de medios de comunicación y otros creadores de contenido que estén dispuestos a promocionar XT.</li><li>2. Sitios web de mercados de criptomonedas, sitios web de herramientas de cifrado, sitios web de medios de comunicación del sector y otros sitios web de criptomonedas.</li><li>3. Promover agentes, agencias u organizaciones, etc.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "¿Cómo ganar comisiones a través del Programa de Afiliados XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Una vez que te hayas convertido en socio de XT, podrás utilizar tu enlace de recomendación para invitar a tus amigos a operar con XT y recibir comisiones de hasta el 55% de las tarifas de transacción del invitado. También puede crear enlaces de recomendación especiales con diferentes descuentos en las comisiones para aumentar la eficacia de sus invitaciones.</p>"
      }
    }, {
      "@type": "Question",
      "name": "¿Durante cuánto tiempo puedo disfrutar de las comisiones de afiliado si me adhiero al programa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Al cumplir los requisitos de umbral, puede recibir un reembolso vitalicio del invitado. Reembolso de por vida - no hay límite máximo ni límite de tiempo. Cuantos más usuarios invites a operar, mayor será el reembolso que recibas.</p>"
      }
    }, {
      "@type": "Question",
      "name": "¿Cómo puedo conseguir referidos de alto nivel en XT?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>Los socios son evaluados mensualmente en función de las cantidades que aportan, si alcanzan el umbral de negociación más bajo para un nivel determinado, recibirán un coeficiente de reembolso para ese nivel.</p>"}
    }]`,
    'zh-CN': `[{
      "@type": "Question",
      "name": "什么是XT合伙人计划？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>我们在寻找认同XT价值观和XT使命，并愿意推广XT的合伙人，因此我们推出了XT合伙人计划，在该计划的后台中，您可以创建独一无二的推荐链接，任何人点击链接并完成注册，即可自动划归为您的被推荐人。无论是XT现货还是合约您都可以调整比例，从被邀请人完成的所有交易中获得佣金。</p>"
      }
    }, {
      "@type": "Question",
      "name": "谁可以加入XT合伙人计划？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. 愿意推广XT的YouTube视频博主、数字货币社区领袖、媒体作者以及其他内容创作者。</li><li>2. 加密货币相关行情网站、加密工具网站、行业媒体网站等加密货币网站。</li><li>3. 推广代理、机构或组织等</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "如何通过XT合伙人计划赚取佣金奖励？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>成功成为XT合伙人后，您可以使用自己的推荐链接邀请好友在XT进行交易，获得被邀请人交易费用最高55%的佣金返还。您还可以创建具有不同费用折扣的特殊推荐链接，以提高邀请效率。</p>"
      }
    }, {
      "@type": "Question",
      "name": "如果我加入该计划，我可以享受多久的会员佣金？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>只要达到对应的门槛要求，你可以获得受邀人提供的终身返佣。终身返佣——没有上限和时间限制。邀请的用户越多交易得越多，获得的返佣越高。</p>"
      }
    }, {
      "@type": "Question",
      "name": "我在XT如何获得更高等级返佣？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>我们每月会根据合伙人所带来的交易量进行评估，如果能够到达指定等级最低交易量的门槛，那么将会获得该等级的返佣比例。</p>"}
    }]`,
    'zh-HK': `[{
      "@type": "Question",
      "name": "什麼是XT合夥人計劃？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>我們在尋找認同XT價值觀和XT使命，並願意推廣XT的合夥人，因此我們推出了XT合夥人計劃，在該計劃的後台中，您可以創建獨一無二的推薦鏈接，任何人點擊鏈接並完成註冊，即可自動劃歸為您的被推薦人。無論是XT現貨還是合約您都可以調整比例，從被邀請人完成的所有交易中獲得佣金。</p>"
      }
    }, {
      "@type": "Question",
      "name": "誰可以加入XT合夥人計劃？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. 願意推廣XT的YouTube視頻博主、數字貨幣社區領袖、媒體作者以及其他內容創作者。</li><li>2. 加密貨幣相關行情網站、加密工具網站、行業媒體網站等加密貨幣網站。</li><li>3. 推廣代理、機構或組織等。</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "如何通過XT合夥人計劃賺取佣金獎勵？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>成功成為XT合夥人後，您可以使用自己的推薦鏈接邀請好友在XT進行交易，獲得被邀請人交易費用最高55%的佣金返還。您還可以創建具有不同費用折扣的特殊推薦鏈接，以提高邀請效率。</p>"
      }
    }, {
      "@type": "Question",
      "name": "如果我加入該計劃，我可以享受多久的會員佣金？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>只要達到對應的門檻要求，你可以獲得受邀人提供的終身返佣。終身返佣——沒有上限和時間限制。邀請的用戶越多交易得越多，獲得的返佣越高。</p>"
      }
    }, {
      "@type": "Question",
      "name": "我在XT如何獲得更高等級返佣？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>我們每月會根據合夥人所帶來的交易量進行評估，如果能夠到達指定等級最低交易量的門檻，那麼將會獲得該等級的返佣比例。</p>"}
    }]`,
    'pt': `[{
      "@type": "Question",
      "name": "O que é o Programa de Parceiros Spikex?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Procuramos parceiros que concordem com os valores e a missão da Spikex e estejam dispostos a promovê-la — por isso criámos o Programa de Parceiros Spikex. Neste programa, pode criar um link de referência único; qualquer pessoa que clicar no link e concluir o registo será automaticamente associada ao seu convite. Pode ajustar as percentagens e ganhar comissões quando os seus convidados concluírem operações à vista, com margem ou futuros na Spikex.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Quem pode aderir ao Programa de Parceiros Spikex?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. Criadores de conteúdo no YouTube, líderes de comunidades de criptomoedas, autores de media e outros criadores que queiram promover a Spikex.</li><li>2. Sites de mercados de criptomoedas, ferramentas, media do setor e outros sites relacionados.</li><li>3. Agências, instituições ou organizações de promoção.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "Como ganhar comissão através do programa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Depois de ser parceiro Spikex com sucesso, pode usar o seu link de referência para convidar amigos a negociar na Spikex e receber até 55% das taxas de transação dos convidados. Também pode criar links especiais com diferentes descontos de taxas para aumentar a eficiência dos convites.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Durante quanto tempo posso usufruir das comissões?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>Enquanto cumprir os requisitos do programa, pode receber comissões vitalícias associadas aos convites. As comissões vitalícias não têm limite temporal nem superior fixo quanto maior for o número de utilizadores convidados e o volume negociado, maior poderá ser a sua comissão.</p>"
      }
    }, {
      "@type": "Question",
      "name": "Como obter comissões de nível mais elevado na Spikex?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>Avaliamos mensalmente o volume de negócios gerado pelo parceiro. Se atingir o limiar mínimo de volume negociado do nível correspondente, passa a beneficiar da taxa de comissão desse nível.</p>"}
    }]`,
    'ar': `[{
      "@type": "Question",
      "name": "ما هو برنامج شركاء Spikex؟",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>نبحث عن شركاء يتفقون مع قيم Spikex ورسالتها ويرغبون في الترويج لها؛ لذلك أطلقنا برنامج شركاء Spikex. يمكنك إنشاء رابط إحالة فريد؛ أي شخص ينقر على الرابط ويكمل التسجيل يُصنَّف تلقائيًا كمدعو من طرفك. يمكنك ضبط النسب وكسب عمولة عندما يُكمل المدعوون أي صفقة في التداول الفوري أو بالهامش أو العقود الآجلة على Spikex.</p>"
      }
    }, {
      "@type": "Question",
      "name": "من يمكنه الانضمام إلى برنامج شركاء Spikex؟",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": " <ul><li>1. صانعو محتوى فيديو على YouTube وقادة مجتمعات العملات المشفرة وصحفيون ومنشئو محتوى مستعدون للترويج لـ Spikex.</li><li>2. مواقع الأسواق والأدوات والإعلام المتعلق بالعملات المشفرة.</li><li>3. وكالات أو مؤسسات أو منظمات ترويجية.</li></ul> "
      }
    }, {
      "@type": "Question",
      "name": "كيف أكسب العمولة من خلال البرنامج؟",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>بعد أن تصبح شريكًا في Spikex بنجاح، يمكنك استخدام رابط الإحالة لدعوة الأصدقاء للتداول على Spikex والحصول على ما يصل إلى 55٪ من رسوم معاملات المدعوين. يمكنك أيضًا إنشاء روابط إحالة خاصة بخصومات رسوم مختلفة لزيادة كفاءة الدعوات.</p>"
      }
    }, {
      "@type": "Question",
      "name": "كم من الوقت يمكنني الاستمتاع بعمولات الشركاء إذا انضممت للبرنامج؟",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "<p>ما دمت تستوفي متطلبات البرنامج، يمكنك الحصول على عمولة مدى الحياة من المدعوين، دون حد أقصى زمني أو مالي ثابت؛ كلما زاد عدد المستخدمين الذين تدعوهم وحجم تداولهم، زادت عمولتك المحتملة.</p>"
      }
    }, {
      "@type": "Question",
      "name": "كيف أحصل على عمولات بمستوى أعلى في Spikex؟",
      "acceptedAnswer": {
        "@type": "Answer",
        "text":"<p>نُقيِّم الشهريًا حجم التداول الذي يجلبه الشريك. إذا بلغ الحد الأدنى من حجم التداول للمستوى المطلوب، يُطبَّق عليك نسبة عمولة ذلك المستوى.</p>"}
    }]`,
  }
  useEffect(()=>{
  },[]);
  return (
    <>
      <Script
        id="jsonLd"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            {
              "@context":
              "http://schema.org",
              "@type": "FAQPage",
              "mainEntity": ${mainEntityMap[lang] ? mainEntityMap[lang] : mainEntityMap['en']}
            }
          `,
        }}
      />
      <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
        <BackHeader title={t("header.affiliate") || "Spikex Partner"} onBack={handleBack} />
        <div style={{ paddingTop: Platform.isInApp() ? "env(safe-area-inset-top, 0px)" : "calc(44px + env(safe-area-inset-top, 0px))" }}>
          <Banner />
          <Content />
        </div>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/affiliate";
  const props = {resolvedUrl};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}
